import { columnVisibilityFeature, tableFeatures } from "@tanstack/react-table"

// react-table v9 requires every table to register the features it uses. The
// team list only needs column visibility, for `row.getVisibleCells()`. This
// lives in its own module because the feature set is the first type parameter
// of every CellContext, so the cell components have to name it too.
export const teamListTableFeatures = tableFeatures({ columnVisibilityFeature })

export type TeamListTableFeatures = typeof teamListTableFeatures
